export default "__VITE_ASSET__O1K3KRFJ__"